import { useState } from 'react'

import { useDeleteAccount } from '../../hooks/use-delete-account'

export const useConfirmWithSubscriptionCard = () => {
  const { isDeletingAccount, handleClickDeleteButton } = useDeleteAccount()

  const [isCheckedToDeleteRightNow, setIsCheckedToDeleteRightNow] = useState(false)

  const handleChangeChecked = () => {
    setIsCheckedToDeleteRightNow((prev) => !prev)
  }

  const isLoadingDeleteButton = isDeletingAccount
  const isDisabledDeleteButton = !isCheckedToDeleteRightNow
  const isDisabledCancelButton = isDeletingAccount

  return {
    isCheckedToDeleteRightNow,
    isLoadingDeleteButton,
    isDisabledDeleteButton,
    isDisabledCancelButton,
    handleChangeChecked,
    handleClickDeleteButton,
  }
}
